// utils/getBatteryOwner.js
// returns true iff:
//  - fueltype === "elektrisch" (case-insensitive, normalisiert)
//  - brand+model (marke + modelSingle) in Whitelist
//  - createdAt >= 2025-11-01T00:00:00+01:00 (CET, i.e. strictly after 31.10.2025)

function stripDiacritics(str) {
  return String(str || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

function normalize(str) {
  return stripDiacritics(str)
    .toLowerCase()
    .replace(/[-_]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function makeKey(marke, modelSingle) {
  return normalize(`${marke || ""} ${modelSingle || ""}`);
}

const WHITELIST_SET = new Set(
  [
    "Renault Zoe",
    "Renault Kangoo",
    "Renault Fluence",
    "Renault Twizy",
    "Renault Master",
    "Nissan Leaf",
    "Nissan NV200",
    "Smart fortwo",
    "Smart forfour",
    "Peugeot iOn",
    "Peugeot Partner",
    "Citroen C-Zero",
    "Citroen Berlingo",
    "Mitsubishi i-MiEV",
    "Mercedes-Benz Vito",
    "Mercedes-Benz eVito",
    "Mercedes-Benz Sprinter",
  ].map((n) => normalize(n))
);

// Midnight CET after Oct 31, 2025
const CUTOFF_MS = Date.parse("2025-10-31T00:00:00+01:00");

// Firestore Timestamp -> ms
function tsToMillis(ts) {
  if (!ts) return NaN;
  // Native Firestore Timestamp
  if (typeof ts.toDate === "function") return ts.toDate().getTime();
  // Serialized shapes (defensiv)
  if (typeof ts.seconds === "number") {
    const nanos = typeof ts.nanoseconds === "number" ? ts.nanoseconds : 0;
    return ts.seconds * 1000 + Math.floor(nanos / 1e6);
  }
  if (typeof ts._seconds === "number") {
    const nanos = typeof ts._nanoseconds === "number" ? ts._nanoseconds : 0;
    return ts._seconds * 1000 + Math.floor(nanos / 1e6);
  }
  return NaN;
}

export function getBatteryOwner(carData) {
  if (!carData) return false;

  // 1) elektrisch
  if (normalize(carData.fueltype || "") !== "elektrisch") return false;

  // 2) Whitelist
  const key = makeKey(carData.marke, carData.modelSingle);
  if (!WHITELIST_SET.has(key)) return false;

  // 3) createdAt >= 2025-11-01 CET
  const createdMs = tsToMillis(carData.createdAt);
  if (!Number.isFinite(createdMs)) return false;

  return createdMs >= CUTOFF_MS;
}
